import { render } from "./AdproAnimation.vue?vue&type=template&id=f0b0aa9a"
import script from "./AdproAnimation.vue?vue&type=script&lang=js"
export * from "./AdproAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__